import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initOfflineSync, flushPendingGratitudes } from "./lib/offlineQueue";
import { initSentryDeferred } from "./lib/sentry-lazy";
import { initChunkErrorRecovery } from "./lib/chunkErrorRecovery";

// Self-heal stale-deploy chunk import failures (clears SW + caches, reloads once).
initChunkErrorRecovery();

// Defer Sentry init to idle time so the ~107 kB gzipped @sentry/react
// chunk doesn't block first paint. Errors thrown before init complete are
// buffered in an in-memory queue and replayed once Sentry is ready (see
// src/lib/sentry-lazy.ts).
const scheduleSentry: (cb: () => void) => void =
  typeof window !== "undefined" && "requestIdleCallback" in window
    ? (window as Window & { requestIdleCallback: (cb: () => void) => void }).requestIdleCallback
    : (cb) => setTimeout(cb, 1500);
scheduleSentry(() => { void initSentryDeferred(); });

// Initialize offline sync (flushes on load + listens for online events)
// Stale-bundle eviction is handled by the service worker's `activate` event
// via CACHE_NAME comparison (see public/sw.js).
initOfflineSync();

// Listen for SW messages to flush gratitude queue
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data?.type === "FLUSH_GRATITUDE_QUEUE") {
      flushPendingGratitudes();
    }
  });
}

createRoot(document.getElementById("root")!).render(<App />);
